var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('UniversalSelectInput',_vm._g(_vm._b({attrs:{"value":_vm.value,"options":_vm.items,"value-key":"id","loading":!_vm.items,"clearable":""}},'UniversalSelectInput',Object.assign({}, {getOptionKey: function (item) { return item.id; },
    getOptionLabel: function (item) { return item.str; }},
    _vm.$attrs),false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }